/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PaymentFormType {
  ORDER = 'order',
  VOUCHER = 'voucher',
  PASS = 'pass',
}
